import { FormValues } from "./getFormValue";
import { MTFiltersValuesI } from "@services/getMinerList";
import { calculateHash } from "./hash.utils";

const formValuesToFilters = (f: FormValues): MTFiltersValuesI => {
  let filters: MTFiltersValuesI = {
    f_admin_mine: false,
  };
  for (const key in f.values) {
    const v = f.values[key];
    if (v === undefined || v === "") {
      continue;
    }

    if (f.badges?.hasOwnProperty(key)) {
      const badge = f.badges[key];
      filters = { ...filters, [key]: calculateHash(v, badge) };
    } else {
      filters = { ...filters, [key]: v };
    }
  }
  return filters;
};

export default formValuesToFilters;
